import { ReactivationSteps } from '@/modules/employer/components/EmployerReactivation/types';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  modalVisible: boolean;
  employerId?: string;
  employerName?: string;
  employerPath?: string;
  additionalAction?: () => void;
  step: ReactivationSteps;

  handleChangeVisibility: (value: boolean) => void;
  handleSetEmployerId: (value?: string) => void;
  handleSetEmployerName: (value?: string) => void;
  handleSetEmployerPath: (value?: string) => void;
  handleSetAdditionalAction: (value?: () => void) => void;
  handleSetStep: (value: ReactivationSteps) => void;
  handleReset: () => void;
}

export const useEmployerReactivationModalStore = storeCreator<State>((set) => ({
  modalVisible: false,
  employerId: undefined,
  employerName: undefined,
  employerPath: undefined,
  additionalAction: undefined,
  step: ReactivationSteps.FORM,

  handleChangeVisibility: (value) => set((state) => ({ ...state, modalVisible: value })),
  handleSetEmployerId: (value) => set((state) => ({ ...state, employerId: value })),
  handleSetEmployerName: (value) => set((state) => ({ ...state, employerName: value })),
  handleSetEmployerPath: (value) => set((state) => ({ ...state, employerPath: value })),
  handleSetAdditionalAction: (value) => set((state) => ({ ...state, additionalAction: value })),
  handleSetStep: (value) => set((state) => ({ ...state, step: value })),
  handleReset: () => set((state) => ({
    ...state,
    modalVisible: false,
    employerId: undefined,
    employerName: undefined,
    employerPath: undefined,
    additionalAction: undefined,
    step: ReactivationSteps.FORM,
  })),
}));
